import React, { useState, useMemo } from 'react';
import { withTranslation } from 'config/i18n';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import Dinero from 'dinero.js';
import PayoutWithdrawDialog from 'components/ownerPages/earningsAndPayouts/earningsBalance/PayoutWithdrawDialog';
import { VERIFIED_STATUSES } from 'components/ownerPages/earningsAndPayouts/utils/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1.5),
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(21),
    },
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(1),
  },
  balance: {
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 900,
    marginBottom: theme.spacing(1),
  },
}));

const EarningsBalance = ({ t, endpointData, refreshPageData }) => {
  const classes = useStyles();

  const owner = endpointData?.owner || null;

  const [open, setOpen] = useState(false); // payout withdraw dialog
  const formatPrice = (value) =>
    `${value.currency_code || ''} ${Dinero({
      amount: value.amount || 0,
    }).toFormat('$0,0.00')}`;

  const userVerified = useMemo(
    () => VERIFIED_STATUSES.includes(owner?.payee_verification_status?.identifier),
    [owner?.payee_verification_status?.identifier]
  );

  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.title}>
        {t('fe_earnings_and_payouts_page:earnings_balance.title')}
      </Typography>
      <Typography variant="h5" className={classes.description}>
        {t('fe_earnings_and_payouts_page:earnings_balance.description')}
      </Typography>
      {owner?.balance && (
        <Typography variant="h3" className={classes.balance}>
          {formatPrice(owner.balance)}
        </Typography>
      )}

      {!userVerified && (
        <Typography variant="h5" className={classes.description}>
          {t('fe_earnings_and_payouts_page:earnings_balance.to_withdraw_complete_verification')}
        </Typography>
      )}
      <Button
        variant="outlined"
        onClick={() => setOpen(true)}
        disabled={!userVerified}
        color="secondary"
      >
        {t('fe_earnings_and_payouts_page:earnings_balance.request_withdrawal')}
      </Button>
      {open && (
        <PayoutWithdrawDialog
          open={open}
          onClose={(success) => {
            setOpen(false);
            if (success) {
              refreshPageData();
            }
          }}
          transferMethods={owner?.transfer_methods}
        />
      )}
    </div>
  );
};

export default withTranslation(['fe_earnings_and_payouts_page'])(EarningsBalance);
